export const siteConfig = { name: 'Agustina Canina', slogan: 'Entenderlos cambia todo', areas: ['Núñez','Villa Urquiza','Belgrano','Palermo','Colegiales','Chacarita','Villa Devoto','Zona Norte'] } as const;
